import React from 'react';

export default function ProductDetail() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 text-center">
      <h1 className="text-3xl font-bold text-slate-900">Chi Tiết Sản Phẩm</h1>
      <p className="text-slate-500 mt-2 text-sm">Trang chi tiết sản phẩm chuẩn bị hiển thị...</p>
    </div>
  );
}